import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getStatDefinitionsQuery } from '../queries/statistics';

import { hydrateWithTranslations } from '@services/TranslatorService';
import type { StatisticDefinition } from '@shared-types/stats.types';
import { uniq } from '@utilities/collection-utils';

export const useStatDefinitions = (statTypes?: string[]) => {
  const { data: statDefinitions } = useQuery({
    ...getStatDefinitionsQuery(),
    select: (res) =>
      res?.map((sd) => ({ ...sd, displayName: hydrateWithTranslations(sd)?.name }) as StatisticDefinition),
  });

  return useMemo(
    () =>
      (statTypes
        ? uniq(statTypes)
            .map((type) => statDefinitions?.find((sd) => sd.name === type))
            .filter(Boolean)
        : statDefinitions) ?? [],
    [statDefinitions, statTypes],
  );
};
